export enum TableColumnTypeEnum {
  String = 1,
  Date = 2,
  DateTime = 3,
  Number = 4,
  Currency = 5,
  Phone = 6,
  Link = 7,
  RawDate = 8,
  RawDateTime = 9,
  LongText = 10,
  Boolean = 11,
  EditableCell = 12,
  Status = 13,
  CustomRenderTemplate = 14,
}
